/* eslint-disable jira/filename-case */
export const V4 = 'v4';

export type NavState = 'v3' | typeof V4;
